type FreelancerSignUpRoute = {
  name: string;
  path: string;
  requireAuth?: boolean;
};

const freelancerRoutes: Record<string, FreelancerSignUpRoute> = {
  addCertificationDocument: {
    name: 'AddCertificationDocument',
    path: '/freelancer/fill-information/qualifications/certification/add-certification',
    requireAuth: true,
  },
  addDiplomasDocument: {
    name: 'AddDiplomasDocument',
    path: '/freelancer/fill-information/qualifications/diplomas/add-diplomas',
    requireAuth: true,
  },
  certificationInformation: {
    name: 'CertificationInformation',
    path: '/freelancer/fill-information/qualifications/certification',
    requireAuth: true,
  },
  competenciesInformation: {
    name: 'CompetenciesInformation',
    path: '/freelancer/fill-information/personal-information/competencies',
    requireAuth: true,
  },
  diplomasInformation: {
    name: 'DiplomasInformation',
    path: '/freelancer/fill-information/qualifications/diplomas',
    requireAuth: true,
  },
  diplomasYearSelection: {
    name: 'DiplomasYearSelection',
    path: '/freelancer/fill-information/qualifications/diplomas/select-year',
    requireAuth: true,
  },
  documentsInformation: {
    name: 'DocumentsInformation',
    path: '/freelancer/fill-information/documents',
    requireAuth: true,
  },
  fillInformation: {
    name: 'FillInformation',
    path: '/freelancer/fill-information',
    requireAuth: true,
  },
  forgotPassword: {
    name: 'ForgotPassword',
    path: '/freelancer/forgot-password',
  },
  insuranceInformation: {
    name: 'InsuranceInformation',
    path: '/freelancer/fill-information/documents/insurance',
    requireAuth: true,
  },
  kvkInformation: {
    name: 'KVKInformation',
    path: '/freelancer/fill-information/kvk-information',
    requireAuth: true,
  },
  landing: {
    name: 'Landing',
    path: '/freelancer/landing',
  },
  login: {
    name: 'Login',
    path: '/freelancer/login',
  },
  personalInformation: {
    name: 'PersonalInformation',
    path: '/freelancer/fill-information/personal-information',
    requireAuth: true,
  },
  personRegister: {
    name: 'PersonRegisterInformation',
    path: '/freelancer/fill-information/documents/person-register',
    requireAuth: true,
  },
  resetPassword: {
    name: 'ResetPassword',
    path: '/freelancer/reset-password',
  },
  signUp: {
    name: 'SignUp',
    path: '/freelancer/sign-up',
  },
  submitApplication: {
    name: 'SubmitApplication',
    path: '/freelancer/fill-information/submit-application',
    requireAuth: true,
  },
  welcome: {
    name: 'Welcome',
    path: '/freelancer/welcome',
    requireAuth: true,
  },
} as const;

export default freelancerRoutes;
